var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonPulse6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 48",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pulseG",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--color-accent,#37E5FF)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-primary,#7C4DFF)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 198,
    height: 46,
    rx: 6,
    ry: 6
  })), /*#__PURE__*/React.createElement("style", null, "\n      .frame { fill: none; stroke: rgba(255,255,255,.14); stroke-width: 2 }\n      .pulse { fill: none; stroke: url(#pulseG); stroke-width: 2; stroke-dasharray: 42 14; stroke-linecap: round;\n               animation: dash 2s linear infinite }\n      @keyframes dash { to { stroke-dashoffset: -400 } }\n      @media (prefers-reduced-motion: reduce) { .pulse { animation: none } }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "frame",
    x: 1,
    y: 1,
    width: 198,
    height: 46,
    rx: 6,
    ry: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "pulse",
    x: 1,
    y: 1,
    width: 198,
    height: 46,
    rx: 6,
    ry: 6,
    clipPath: "url(#r6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPulse6);
export default __webpack_public_path__ + "static/media/button-pulse-6.cddb8fe33febff0bb01db6fa2d35a82f.svg";
export { ForwardRef as ReactComponent };